import { useEffect, useContext } from "react";
import { Box, Button } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import { SalesBranchReport } from "../../../global/API";
import { DataSetArray } from "./DataSetArray";
import moment from "moment";
import Excel from '../../../../../assets/images/icons/excel.png';
import ReactExport from 'react-data-export';
import { ToolContext } from "../../../../../core/context/ToolContext";

import { FeatureIdState } from "../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../global/API";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export const Generate = () => {
    const {tool_state, report_state, setup_state} = useContext(ToolContext)
    const {__SESSION} = tool_state
    const {form, generateForm, salesBranchData, salesBranchList} = report_state
    const {snackBarLoader} = setup_state
    const tool_id =  process.env.REACT_APP_TID_BIZ;


    const handleGenerate = async() => {
        __generateData(0)
    }

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('reports')}->1`,
            feature_id: 1,
            feature_name: "branch-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }

    const __generateData = async(offset) => {
        if (form.data.to === '' || form.data.from === '' || form.data.to < form.data.from) {
            snackBarLoader.set({...snackBarLoader.data, snackbar:true, msg: `Invalid Date!`})
            return
        }else{
            generateForm.set((prev) => ({...prev, infiniteLoad:true}))
        }
        let qsp = {
            branch_id:form.data.branch_id,
            company_id:__SESSION.data.uaccess[0].company_id,
            user_id:form.data.user_id,
            from:form.data.from,
            to:form.data.to,
            limit:generateForm.data.limit,
            offset:offset   
        }

        let res = await SalesBranchReport(qsp)
        SendFeatureLogs()
        if (res) {
            if (res.length === 0) {
                FormatData([...salesBranchData.data, ...res])
                return
            }else{
                ///// LOADER VALIDATION
                if (res.length < generateForm.data.limit) {
                    FormatData([...salesBranchData.data, ...res])
                    return
                }else{
                    generateForm.set((prev) => ({...prev, offset:res.length + salesBranchData.data.length}))
                }
                ///// STATE LIST DATA
                salesBranchData.set([...salesBranchData.data, ...res])
            }   
        }
    }

    const FormatData = (salesBranchData) => {
        const groupedData = salesBranchData.reduce((acc, item) => {
            const { date, id, total_sales, created_at, company_branch_id, actual_sales, variance, remarks } = item;
            const key = `${id}-${date}-${company_branch_id}`;
        
            if (!acc[key]) {
                acc[key] = {...item,
                    remarks:remarks===null? '': remarks,
                    variance:variance === null ? 0 : variance,
                    actual_sales:actual_sales === null ? 0 : actual_sales,
                    total_sales: parseFloat(total_sales) || 0,
                    date : id === null ? moment(created_at).format("YYYY-MM-DD") : date
                };
            } else {
                acc[key].total_sales += parseFloat(total_sales) || 0;
            }
        
                return acc;
            }, {});
        
        const result = Object.values(groupedData);
        salesBranchList.set(result)
        generateForm.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
        salesBranchData.set([])
    }

    useEffect(() => {
        if (generateForm.data.offset !== 0) {
            __generateData(generateForm.data.offset)
        }
        //eslint-disable-next-line
    }, [salesBranchData.data])

    return (
        <Box minHeight="55px" display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
            {salesBranchList.data.length > 0 && (
                <ExcelFile filename={`Sales_Product_Reports_${moment(new Date()).format('MM/DD/YYYY')}`}
                    element={
                        <Box display="flex" alignItems="center" className="c-pointer" bgcolor="#d5ffe6ff" borderRadius={2} padding="12px 16px" minWidth="200px">
                            <img src={Excel} alt="excel-img" />
                            <Box ml="10px" color="#1D6F42">Export in excel</Box>
                        </Box>
                    }
                >
                    <ExcelSheet dataSet={DataSetArray(salesBranchList.data)} name="Reports" />
                </ExcelFile>
            )}
            <Box id="walkthrough-branch-sales-report-step-5" onClick={handleGenerate} component={Button} disableFocusRipple={true} minHeight="50px" minWidth="130px" borderRadius={3} display="flex" alignItems="center" justifyContent="center" bgcolor="primary.main" color="#fff" sx={{border:"2px solid #EBEBEB", ':hover':{bgcolor:'primary.main', color:'#FFFFFF'}}} startIcon={<SyncIcon/>}>
                <Box fontSize={16} fontWeight={400} lineHeight="19px">Generate</Box>
            </Box>
        </Box>
    )
}